const CoffeeICon = ({ className, stroke }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M35.58 20.94V35.58C35.58 40.24 31.8 44 27.16 44H12.42C7.78 44 4 40.22 4 35.58V20.94C4 16.28 7.78 12.52 12.42 12.52H27.16C31.8 12.52 35.58 16.3 35.58 20.94Z"
        stroke={stroke || "#F1F3F8"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 8V4.5"
        stroke={stroke || "#F1F3F8"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 8V4.5"
        stroke={stroke || "#F1F3F8"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 8V4.5"
        stroke={stroke || "#F1F3F8"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.0001 26.32C44.0001 30.96 40.2201 34.74 35.5801 34.74V17.9C40.2201 17.9 44.0001 21.66 44.0001 26.32Z"
        stroke={stroke || "#F1F3F8"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 24H35.02"
        stroke={stroke || "#F1F3F8"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CoffeeICon;
